import { render, staticRenderFns } from "./addMessageField.vue?vue&type=template&id=9fa2725e&scoped=true&"
import script from "./addMessageField.vue?vue&type=script&lang=js&"
export * from "./addMessageField.vue?vue&type=script&lang=js&"
import style0 from "./addMessageField.vue?vue&type=style&index=0&id=9fa2725e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa2725e",
  null
  
)

export default component.exports